import { AuthRepository } from "../../api/repositories/backend/auth";
import { setGlobalState } from "../hooks/global-state";
import { isNothing } from "../utils";

export class AuthService {
    private authRepository: AuthRepository;

    constructor() {
        this.authRepository = new AuthRepository();
    }

    async initAuth() {
        const user = await this.authRepository.getAuthorized();
        const authorizedUser = user && user.authorized
            ? user
            : undefined;

        setGlobalState("authorizedUser", authorizedUser)
    }

    redirectSteamAuth() {
        const params = [
            ["openid.ns", "http://specs.openid.net/auth/2.0"],
            ["openid.mode", "checkid_setup"],
            ["openid.return_to", `${window.location.protocol}//${window.location.host}/api/auth/steam_login`],
            ["openid.realm", `${window.location.protocol}//${window.location.host}`],
            ["openid.identity", "http://specs.openid.net/auth/2.0/identifier_select"],
            ["openid.claimed_id", "http://specs.openid.net/auth/2.0/identifier_select"],
        ] as const

        window.location.href = `https://steamcommunity.com/openid/login?${params.map(([k, v]) => `${k}=${v}`).join("&")}`
    }

    async logout() {
        await this.authRepository.logout();
        setGlobalState("authorizedUser", undefined)
    }
}